<template>
  <div :class="classes()">
    <div :class="`${el}__top`">
      <Row>
        <Col :xs="12" :l="3" :class="`${el}__col`">
          <div :class="`${el}__outer ${el}__head`">
            <Picture :class="`${el}__headImage`" :img="head.image" responsive />
            <Headline size="xs" color="neutral80" noMargin><div v-html="head.copy" /></Headline>
          </div>
          <svg
            v-if="$matchMedia.l"
            :width="40"
            viewBox="0 0 40 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :style="`background-color: ${colors.secondaryMintLighter}`"
          >
            <path
              d="M39.5 80L-3.09447e-05 160L-3.8147e-05 -6.58175e-05L39.5 80Z"
              :fill="`${colors.secondaryMint}`"
            />
          </svg>
        </Col>
        <Col :xs="12" :l="6">
          <div :class="`${el}__body`">
            <div :class="`${el}__bodyInner`">
              <Copy :staticClass="`${el}__bodyCopy`" element="div">{{ body.copy }}</Copy>
              <ul :class="`${el}__bodyList`">
                <li
                  v-for="(text, i) in body.list"
                  :key="`bodyListItem-${i}`"
                  :class="`${el}__bodyListItem`"
                >
                  {{ text.trim() }}
                </li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
    </div>

    <div :class="`${el}__radioGroups`">
      <div :class="`${el}__radioGroupAnswer`">
        <Copy element="div" :staticClass="`${el}__radioGroupFormsHeadline`" bold>
          {{ bottomBoxSupport.question }}
        </Copy>
        <Copy element="div">
          {{ bottomBoxSupport.answerPrefix }}
          <strong>{{ bottomBoxSupport.answer }}</strong>
        </Copy>
      </div>

      <div :class="`${el}__radioGroup ${el}__radioGroup--visible`">
        <div :class="`${el}__radioGroupForms`">
          <Copy element="div" :staticClass="`${el}__radioGroupFormsHeadline`" bold>
            {{ radioGroup.headline }}
          </Copy>
          <slot :name="radioGroup.slotName" />
        </div>
      </div>

      <div v-if="stressBar" :class="`${el}__stressBar`">
        <Copy element="div" :staticClass="`${el}__radioGroupFormsHeadline`" bold>
          {{ stressBar.headline }}
        </Copy>
        <slot name="stressBar" />
      </div>

      <div :class="`${el}__btn`">
        <slot name="modalCloseButton" />
      </div>
    </div>
  </div>
</template>

<script>
import Picture from '@/objects/Picture';
import Headline from '@/objects/Headline';
import Copy from '@/objects/Copy';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';
import colors from '@/styles/base/_colors.scss';

export default {
  name: 'SwitcherRow',
  props: {
    // content: Object,
    head: {
      image: String,
      copy: String,
    },
    body: {
      copy: String,
      list: Array,
    },
    switcher: {
      copy: String,
    },
    bottomBoxSupport: {
      question: String,
      answerPrefix: String,
      answer: String,
    },
    stressBar: {
      headline: String,
    },
    radioGroupHeadline: String,
    radioGroup: {
      headline: String,
      slotName: Object,
      visible: Boolean,
    },
  },
  components: {
    Picture,
    Headline,
    Copy,
    Row,
    Col,
  },
  data() {
    return {
      // ...this.content,
      colors,
      el: 'c-switcherRow',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
};
</script>
